import {useI18n} from '@/i18n'
import {DetailGrid} from '@/components/shared/DetailGrid'
import {Stack} from '@/components/shared/Stack'
import {AttributeValueInput} from '@/components/attributes/AttributeValueInput'
import type {AttributeDefinition} from '@/types/attribute-definition'
import {MutedText} from '@/components/shared/MutedText'

interface ParameterFormProps {
    parameters: AttributeDefinition[]
    values: Record<string, string>
    onChange: (values: Record<string, string>) => void
}

export function ParameterForm({parameters, values, onChange}: ParameterFormProps) {
    const i18n = useI18n()

    if (parameters.length === 0) return null

    return (
        <Stack gap="sm" data-testid="parameter-form">
            <MutedText size="sm" className="font-medium">{i18n.reporting.parameters.title}</MutedText>
            <DetailGrid columns={2}>
                {parameters.map(param => (
                    <AttributeValueInput
                        key={param.name}
                        definition={param}
                        value={values[param.name] ?? ''}
                        onChange={(v) => onChange({...values, [param.name]: v})}
                        testId={`param-${param.name}`}
                        inline
                    />
                ))}
            </DetailGrid>
        </Stack>
    )
}
